<template>
  <div class="report-to-province" v-if="form">
    <div class="rtp-hd">
      <h3 class="rtp-title">上报省平台</h3>
    </div>
    <div class="rtp-bd">
      <el-radio-group v-model="form.IS_REPORT_PROVINCE_OUTSIDE" class="rtp-radio">
        <el-radio :label="true">上报</el-radio>
        <el-radio :label="false">不上报</el-radio>
      </el-radio-group>
      <div class="rtp-remark">
        <strong class="red">温馨提醒：您的项目公告已经成功在省网发布，请您按省网最终发布的内容调整交易平台必要信息，再次提交即可在交易平台发布。</strong>
      </div>
      <div class="rtp-login">
        <p>
          <strong>请先使用：“福建省公共资源交易电子公共服务平台”代理机构账号登陆，再进行数据上报</strong>
        </p>
        <el-form ref="loginForm" :model="userForm" :rules="userRules" :show-message="false">
          <el-row>
            <el-col :span="5" class="rtp-login-item">
              <el-form-item prop="UserName" label="账号">
                <el-input v-model="userForm.UserName"></el-input>
              </el-form-item>              
            </el-col>
            <el-col :span="5" class="rtp-login-item">
              <el-form-item prop="Password" label="密码">
                <el-input v-model="userForm.Password"></el-input>
              </el-form-item>              
            </el-col>
            <el-col :span="5" class="rtp-login-item">
              <el-form-item prop="CheckCode" label="验证码">
                <el-input v-model="userForm.CheckCode"></el-input>
              </el-form-item>              
            </el-col>
            <el-col :span="5" class="rtp-login-item">
              <img v-if="host" :src="checkCodeUrl" @click="resetCheckUrl" alt="">
              <el-button type="primary" @click="doLogin">登录</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState, mapActions} from 'vuex'
export default {
  name: 'BearReportToProvince',
  data() {
    return {
      userForm: {
        UserName: '',
        Password: '',
        CheckCode: ''
      },
      userRules: {
        UserName: [{required: true, trigger: 'change'}],
        Password: [{required: true, trigger: 'change'}],
        CheckCode: [{required: true, trigger: 'change'}],
      },
      checkCodeUrl: '',
      isLogin: false,
      gonggaoState: false
    }
  },
  computed: {
    ...mapState(['form']),
    ...mapState('reportToProvince', ['host', 'plat'])
  },
  methods: {
    ...mapActions('reportToProvince', ['requestToLogin', 'requestGongGaoProperty', 'requestGGFWConfig']),
    resetCheckUrl() {
      this.checkCodeUrl = `${this.host}/Home/CheckCode?t=${Date.now()}`
    },
    doLogin() {
      this.$refs.loginForm.validate(res => {
        if(res) {
          this.requestToLogin(this.userForm).then(res => {
            if(res.Status === 0) {
              this.isLogin = true
              this.$message.success('登陆成功')
              this.initFormConfig()
            } else {
              this.$alert(res.Error.ErrorMessage || res.Error, '操作提示', {
                type: 'error'
              })
            }
            this.resetCheckUrl()
          })
        } else {
          this.$alert('请确认填写账号/密码/验证码，再点击登录', '操作提示', {
            type: 'info'
          })
        }
      })
    },
    initFormconfig() {
      this.requestGongGaoProperty().then(res  => {
        if(res.Status === 0) {
          let {list} = res
          list.forEach(obj => {

          })
        } else {
          this.$alert(res.Msg, '操作提示', {
            type: 'info'
          })
        }
      })
    },
    resetUnitForConfig(obj) {
      let options = {
        BID_AMOUNT: '元'
      }
      return obj.Unit || `(${options[obj.FName]})` || ''
    },
    initGGFWConfig(obj) {
      this.requestGGFWConfig().then(res => {
        let config = {}
        res.DataFields.forEach(field => {
          config[field.FName] = field
        })
        obj.Propertys.forEach(property => {
          let field = config[property.Key]
          let unit = resetUnitForConfig(field)
          property.config = {
            name: field.FValue,
            key: field.FName,
            type: field.ControlType,
            ftype: field.Ftype,
            Unit: unit,
            ForeignData: field.ForeignData,
            FieldPar: this.transStrToJson(field.FieldPar),
            MaxLen: field.MaxLen
          }
          if(field.ControlType === '12' && property.Value) {
            
          }
        })
      })
    },
    transStrToJson(str) {
      if(!str) return null
      return eval(`(${
        str.replace(/(\/\/|\/\*)[^\n]+/g, '').replace(/XMFLClick/g, '""')
      })`)
    },
    validForm(call) {
      this.$refs.form.validate().then(
        e => call(true)
      ).catch(
        e => call(false)
      )
    },
  }
}
</script>
<style lang="scss" scoped>
.report-to-province {
  width: 900px;
  margin: 0 auto 15px;
  box-sizing: border-box;
  background: white;
  box-shadow: 0px 0px 5px 1px #aaabaf;
  border: 1px solid #20A0FF;
  .rtp-hd {
    position: relative;
    text-align: center;
    color: white;
    background: #20A0FF;
    .rtp-title {
      margin: 0;
      font: bold 20px/50px microsoft yahei;
    }
  }
  .rtp-bd{
    margin-top: 15px;
    padding: 0px 30px 30px;
    font: normal 14px/23px microsoft yahei;
    transition: all cubic-bezier(0.68, -0.55, 0.265, 1.55);
    .rtp-remark {
      line-height: 30px;
    }
    .rtp-login-item {
      margin-right: 10px;
    }
  }
  .red {
    color: red;
  }
}
</style>